import "../styles/RoundLogs.css"
import { PerPlayerRoundLogItem } from "./items/PerPlayerRoundLogItem"
export const RoundLogs = ({ logs, size }) => {
    return (<div className={`round-logs-container-${size}`}>
        {logs.map((player, index) => {
            return (
                <div key={`player_logs_${index}`} className={`player-round-logs-container-${size}`}>
                    <div style={{ display: "flex" }}>
                        <img src={player.photoUrl} alt="" style={{ width: `${size === "lg" ? "3vw" : "40px"}`, height: `${size === "lg" ? "3vw" : "40px"}`, borderRadius: `${size === "lg" ? "1.5vw" : "20px"}`, marginRight: "10px" }} />
                        <div className={`round-logs-header`}>
                            {player.name}
                        </div>
                    </div>
                    <div>
                        {player.roundLog && player.roundLog.map((value, logIndex) => {
                            return <PerPlayerRoundLogItem key={`player_${index}_log_${logIndex}`} size={size} message={value.message} company={value.company} />
                        })}
                    </div>
                </div>
            )
        })}
    </div>)
}